import {
  combineReducers
} from 'redux';
import {
  routerReducer
} from 'react-router-redux';
import visibilityReducer from './visibilityReducer';
import authenticationReducer from './authenticationReducer';
import usersReducer from './usersReducer';
import personasReducer from './personasReducer';

export default combineReducers({
  routing: routerReducer,
  visibility: visibilityReducer,
  authentication: authenticationReducer,
  users: usersReducer,
  personas: personasReducer
});



// WEBPACK FOOTER //
// ./client/store/reducers/index.js